"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "paola": {
    "373e0176": [{
      "hkey": "eb4c919c",
      "slug": "fosse",
      "name": "Fosse",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-fosse": [{
      "hkey": "eb4c919c",
      "slug": "fosse",
      "name": "Fosse",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "13fb8773": [{
      "hkey": "6bff9090",
      "slug": "sotterra",
      "name": "Sotterra",
      "primary": true,
      "skipSearch": false
    }],
    "gaudimare": [{
      "hkey": "6bff9090",
      "slug": "sotterra",
      "name": "Sotterra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d41a1ec6": [{
      "hkey": "d9da0b0d",
      "slug": "paola",
      "name": "Paola",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agata": [{
      "hkey": "d9da0b0d",
      "slug": "paola",
      "name": "Paola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;